/**
 * AUTO-GENERATED - DO NOT EDIT MANUALLY
 *
 * Generated by: npm run images:process
 * Source: data/wallpapers-source/
 *
 * Each entry corresponds to a source image that was processed into
 * AVIF + WebP at responsive widths in .generated/wallpapers/
 * and published to Cloudflare R2.
 */

export interface GeneratedWallpaper {
  /** Unique ID derived from source filename (kebab-case) */
  id: string;
  /** Human-readable display name (auto-generated from filename) */
  name: string;
  /** Primary AVIF URL */
  url: string;
  /** WebP fallback URL */
  urlWebp: string;
  /** Small AVIF URL used only by theme-picker cards */
  previewUrl?: string;
  /** Small WebP fallback URL used only by theme-picker cards */
  previewUrlWebp?: string;
}

/**
 * All available wallpapers, dynamically generated from source images.
 * The number of entries here directly determines the number of Premium themes.
 */
export const GENERATED_WALLPAPERS: GeneratedWallpaper[] = [
  {
    id: 'alpine-stars',
    name: 'Alpine Stars',
    url: 'https://assets.kanadojo.com/wallpapers/alpine-stars-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/alpine-stars-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/alpine-stars-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/alpine-stars-480w.webp',
  },
  {
    id: 'bangkok-grand-palace-fireworks',
    name: 'Bangkok Grand Palace Fireworks',
    url: 'https://assets.kanadojo.com/wallpapers/bangkok-grand-palace-fireworks-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-grand-palace-fireworks-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/bangkok-grand-palace-fireworks-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-grand-palace-fireworks-480w.webp',
  },
  {
    id: 'bangkok-night',
    name: 'Bangkok Night',
    url: 'https://assets.kanadojo.com/wallpapers/bangkok-night-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-night-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/bangkok-night-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-night-480w.webp',
  },
  {
    id: 'bangkok-night-pool',
    name: 'Bangkok Night Pool',
    url: 'https://assets.kanadojo.com/wallpapers/bangkok-night-pool-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-night-pool-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/bangkok-night-pool-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-night-pool-480w.webp',
  },
  {
    id: 'bangkok-park',
    name: 'Bangkok Park',
    url: 'https://assets.kanadojo.com/wallpapers/bangkok-park-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-park-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/bangkok-park-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-park-480w.webp',
  },
  {
    id: 'bangkok-river',
    name: 'Bangkok River',
    url: 'https://assets.kanadojo.com/wallpapers/bangkok-river-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-river-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/bangkok-river-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-river-480w.webp',
  },
  {
    id: 'bangkok-riverside-night',
    name: 'Bangkok Riverside Night',
    url: 'https://assets.kanadojo.com/wallpapers/bangkok-riverside-night-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-riverside-night-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/bangkok-riverside-night-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-riverside-night-480w.webp',
  },
  {
    id: 'bangkok-storm',
    name: 'Bangkok Storm',
    url: 'https://assets.kanadojo.com/wallpapers/bangkok-storm-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-storm-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/bangkok-storm-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-storm-480w.webp',
  },
  {
    id: 'bangkok-sunset',
    name: 'Bangkok Sunset',
    url: 'https://assets.kanadojo.com/wallpapers/bangkok-sunset-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-sunset-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/bangkok-sunset-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/bangkok-sunset-480w.webp',
  },
  {
    id: 'blue-mountain-sunrise',
    name: 'Blue Mountain Sunrise',
    url: 'https://assets.kanadojo.com/wallpapers/blue-mountain-sunrise-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/blue-mountain-sunrise-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/blue-mountain-sunrise-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/blue-mountain-sunrise-480w.webp',
  },
  {
    id: 'chureito-fuji-sunset',
    name: 'Chureito Fuji Sunset',
    url: 'https://assets.kanadojo.com/wallpapers/chureito-fuji-sunset-1920w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/chureito-fuji-sunset-1920w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/chureito-fuji-sunset-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/chureito-fuji-sunset-480w.webp',
  },
  {
    id: 'crimson-coder',
    name: 'Crimson Coder',
    url: 'https://assets.kanadojo.com/wallpapers/crimson-coder-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/crimson-coder-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/crimson-coder-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/crimson-coder-480w.webp',
  },
  {
    id: 'dawn-pagoda',
    name: 'Dawn Pagoda',
    url: 'https://assets.kanadojo.com/wallpapers/dawn-pagoda-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/dawn-pagoda-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/dawn-pagoda-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/dawn-pagoda-480w.webp',
  },
  {
    id: 'dubai-skyline',
    name: 'Dubai Skyline',
    url: 'https://assets.kanadojo.com/wallpapers/dubai-skyline-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/dubai-skyline-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/dubai-skyline-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/dubai-skyline-480w.webp',
  },
  {
    id: 'island-night',
    name: 'Island Night',
    url: 'https://assets.kanadojo.com/wallpapers/island-night-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/island-night-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/island-night-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/island-night-480w.webp',
  },
  {
    id: 'marina-sunset',
    name: 'Marina Sunset',
    url: 'https://assets.kanadojo.com/wallpapers/marina-sunset-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/marina-sunset-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/marina-sunset-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/marina-sunset-480w.webp',
  },
  {
    id: 'moonlit-crossing',
    name: 'Moonlit Crossing',
    url: 'https://assets.kanadojo.com/wallpapers/moonlit-crossing-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/moonlit-crossing-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/moonlit-crossing-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/moonlit-crossing-480w.webp',
  },
  {
    id: 'moraine-lake-sunrise',
    name: 'Moraine Lake Sunrise',
    url: 'https://assets.kanadojo.com/wallpapers/moraine-lake-sunrise-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/moraine-lake-sunrise-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/moraine-lake-sunrise-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/moraine-lake-sunrise-480w.webp',
  },
  {
    id: 'neon-cafe',
    name: 'Neon Cafe',
    url: 'https://assets.kanadojo.com/wallpapers/neon-cafe-1920w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/neon-cafe-1920w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/neon-cafe-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/neon-cafe-480w.webp',
  },
  {
    id: 'retro-city',
    name: 'Retro City',
    url: 'https://assets.kanadojo.com/wallpapers/retro-city-1920w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/retro-city-1920w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/retro-city-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/retro-city-480w.webp',
  },
  {
    id: 'tokyo-tower',
    name: 'Tokyo Tower',
    url: 'https://assets.kanadojo.com/wallpapers/tokyo-tower-2560w.avif',
    urlWebp: 'https://assets.kanadojo.com/wallpapers/tokyo-tower-2560w.webp',
    previewUrl: 'https://assets.kanadojo.com/wallpapers/tokyo-tower-480w.avif',
    previewUrlWebp: 'https://assets.kanadojo.com/wallpapers/tokyo-tower-480w.webp',
  },
];
